(function () {
	'use strict';

	angular.module('app.core')
		.directive('inventoryActionResultsChart', inventoryActionResultsChart);

	function translateQueryParam(string){
		switch(string){
		case 'Fixed':
			return 'isFixed';
		case 'Unable to Fix':
			return 'isUnableToFix';
		case 'Expired':
			return 'isExpired';
		case 'Open':
			return 'isOpen';
		default:
			return undefined;
		}
	}

	function inventoryActionResultsChart($window, $filter, $rootScope, $timeout,
			$state, integerFormatService, currencyFormatService, $translate, leanFilterService) {

		return {
			restrict: 'A',
			scope: {},
			link: function (scope, elem, attrs) {
				var scopeAccessor = scope.$parent.$parent;

				scope.chartData = scopeAccessor.chartData;
				scope.currency = scopeAccessor.currency;
				var chart;
				var chartListener;
				var yAxisFieldLabel = '';
				var xAxisFieldLabel = '';
				var data = [];
				var numAxisTicks = 3;

				var w = angular.element($window);
				var width = Math.max(w.width(), window.innerWidth);
				scope.height = window.innerHeight;
				scope.paddingTop = 4;
				scope.paddingBottom = 0;
				// give element unique id
				elem[0].id = elem[0].id + scope.$id;
				var chartHeight = 250;
				if (scope.chartHeight) {
					chartHeight = scope.chartHeight;
				}
				var initialGeneration = false;

				var slideshow = false;
				if (jQuery(elem[0]).parents('.slideshowWidget').length) {
					slideshow = true;
					scope.paddingTop = 8;
					numAxisTicks = 5;
					scope.paddingBottom = 12;
				}
				setPadding();

				scope.$watch(getWindowDimensions2, function (newValue, oldValue) {
					scope.windowWidth2 = newValue.w;
					scope.height = newValue.h;
					var currentPaddingLeft = scope.paddingLt;

					setPadding();

					if (initialGeneration && (currentPaddingLeft !== scope.paddingLt || newValue.h !== oldValue.h || slideshow)) {
						generateChart();
					}
				}, true);

				w.bind('resize', function () {
					scope.$apply();
				});

				function getWindowDimensions2() {
					return {
						'w': Math.max(w.width(), window.innerWidth),
						'h': window.innerHeight
					};
				}

				function setPadding() {
					if (slideshow) {
						chartHeight = scope.height - 130 - 65;
						scope.paddingLt = 75;
						scope.paddingRt = 22;
					} else if (scope.windowWidth2 >= 992) {
						scope.paddingLt = 59;
						scope.paddingRt = 35;
						scope.axisLabelWidth = 50;
					} else if (scope.windowWidth2 >= 768) {
						scope.paddingLt = 48;
						scope.paddingRt = 30;
						scope.axisLabelWidth = 50;
					} else {
						scope.paddingLt = 36;
						scope.paddingRt = 30;
						scope.axisLabelWidth = 30;
					}
				}

				function generateChart() {
					setPadding();
					var i;
					var groups = ['Fixed', 'Unable to Fix', 'Expired', 'Open'];
					var translatedGroups = {
						'Fixed': $translate.instant('Fixed'),
						'Unable to Fix': $translate.instant('Unable to Fix'),
						'Expired': $translate.instant('Expired'),
						'Open': $translate.instant('Open')
					};
					scope.translatedGroups = translatedGroups;
					var data = scopeAccessor.chartData ? scopeAccessor.chartData : [];
					var currency = scopeAccessor.currency;
					var mode = 'Savings';
					var dateList = [];
					angular.forEach(data, function (dp) {
						dateList.push($filter('date')(dp.date, 'mediumDate', 'UTC'));
					});
					var yAxisCategories = scopeAccessor.categories;
					var startTimestamp = (data && data.length) ? data[0].date : 0;
					var endTimestamp = (data && data.length) ? data[data.length - 1].date : 0;
					// one day
					var interval = 7 * 60 * 60 * 24 * 1000;
					
					var possiblePoints = data.length;
					var elementWidth = jQuery('#' + elem[0].id).width();
					if (elementWidth == 0) {
						// sometimes element is empty so use reasonable fallback to prevent thin bars
						elementWidth = $(window).width() / 3;
					}
					var max = 0;
					if (data && data.length) {
						max = data[0]['Total'];
						for (var i = 0; i < data.length; i++) {
							if (data[i]['Total'] > max) {
								max = data[i]['Total'];
							}
						}
					}
					// add more space in y-axis for big values
					if (max >= 10000000) {
						scope.paddingLt += 5;
					}
					if (max >= 100000000) {
						scope.paddingLt += 5;
					}
					if (max >= 1000000000) {
						scope.paddingLt += 10; // adds a comma
					}
					if (max >= 10000000000) {
						scope.paddingLt += 5;
					}
					if (currency) {
						scope.paddingLt += (10 * (currency.length - 1));
					}
					var chartWidth = elementWidth - scope.paddingLt - scope.paddingRt;
					var barWidth = chartWidth / possiblePoints;

					var timeRange = getTimeRange(data, 'date');
					getYMax(max, numAxisTicks, true);

					var yMax;

					function getYMax(curMax, numTicks, integer) {
						var multiple = numTicks - 1;
						yMax = curMax;
						yMax = yMax * 1.05;
						if (integer) {
							yMax = Math.ceil(yMax);
							var diff = yMax;
							var newDiff = Math.ceil(diff / multiple) * multiple;
							yMax = newDiff;
						}
					}

					var config = {};
					// tell c3 where to put the chart
					config.bindto = '#' + elem[0].id;
					config.size = {
						height: chartHeight
					};
					config.padding = {
						right: scope.paddingRt,
						left: scope.paddingLt,
						top: scope.paddingTop
					};

					config.bar = {
						width: barWidth * 0.5
					};

					config.data = {
						json: data,
						type: 'bar',
						keys: {
							value: groups
						},
						groups: [groups],
						order: null,
						names: translatedGroups,
						color: function (color, d) {
							var colorCode = color;
							if (d === 'Fixed' || d.id === 'Fixed') {
								colorCode = '#0C9D4D';
							} else if (d === 'Unable to Fix' || d.id === 'Unable to Fix') {
								colorCode = '#D30A0A';
							} else if (d === 'Expired' || d.id === 'Expired') {
								colorCode = '#F4CE00';
							} else if (d === 'Open' || d.id === 'Open') {
								colorCode = '#005FA5';
							}
							return colorCode;
						},
						selection: {
							'enabled': true
						},
						onclick: function (d, i) {
							var filterQueryParams = scopeAccessor.leanFilterService.getQueryParamsObject(true, true);
							if (globalConfig.factory.id !== scopeAccessor.leanFilterService.getFactoryList()) {
								filterQueryParams['factory'] = scopeAccessor.leanFilterService.getFactoryList();
							}
							if (scopeAccessor.ignoreFilters) {
								filterQueryParams = _.omit(filterQueryParams, scopeAccessor.ignoreFilters);
							}

							if (data[d.index].weekStart && data[d.index].weekEnd) {
								filterQueryParams.creationDateValueOne = data[d.index].weekStart;
								filterQueryParams.creationDateValueTwo = data[d.index].weekEnd;
								filterQueryParams.creationDateComparator = 'btw';
							}

							var stateParams = {
								reportingPeriods: data[d.index].reportingPeriods,
								// translate dashboard filters to report filters
								'filters': filterQueryParams,
								siteIds: scopeAccessor.leanFilterService.getFactoryList()
							};
							$state.go('app.supply-chain.inventory-actions', stateParams);
						}
					};

					config.grid = {
						x: {
							show: false
						},
						y: {
							show: true
						}
					};

					config.legend = {
						show: true,
						item: {
							onclick: function (id) {
								chart.toggle(id);
								var selectedKeys = [];
								// update bgnum and delta
								var visibleValue = 0.0;
								var i;

								var visibleData = chart.data.shown();
								for (i = 0; i < visibleData.length; i++) {
									selectedKeys.push(visibleData[i].id);
								}

								var url = decodeURIComponent(scope.$parent.content.drillDownUrl);
								var params = parseQueryString(url);
								var baseUrl = url.split('?')[0];
								// clear out existing inventoryActionStatus query params
								delete params.inventoryActionStatus;
								if (selectedKeys.length != groups.length) {
									var tmpArr = [];
									selectedKeys.toString().split(',').forEach(function (s){
										tmpArr.push(translateQueryParam(s));
									});
									params['inventoryActionStatus'] = tmpArr.join(',');
								}
								scope.$parent.content.drillDownUrl = addQueryParam(baseUrl, null, params, false);
							}
						}
					};

					var formatService = currencyFormatService;
					config.axis = {
						rotated: false,
						x: {
							type: 'category',
							categories: dateList,
							tick: {
								count: 5,
								outer: false,
								multiline: false
							}
						},
						y: {
							tick: {
								format: function (x) {
									return formatService.get(x, currency);
								},
								count: numAxisTicks
							},
							min: 0,
							max: yMax,
							padding: {
								bottom: 0,
								top: 0
							}
						}
					};
					initialGeneration = true;
					chart = c3.generate(config);
				}

				scope.$watch(function () {
					return jQuery('.inventory-action-results-chart .c3-legend-item-tile').last().attr('x1');
				});

				chartListener = scope.$on('event:inventoryActionResultsCtrl:getChart', function () {
					generateChart();
				});

				scope.$on('$destroy', function () {
					if (chart) {
						chart.destroy();
					}
					if (chartListener) {
						chartListener();
					}
				});
			}
		};
	}
})();
